// Clear storage for token and fetch new token.
export const handleRefreshToken = () => {
  localStorage?.removeItem('msal-token');
  sessionStorage?.clear();
  window.location.reload();
};
